<template>
  <div class="py-4 container-fluid">
      <div class="row">
        <div class="text-right col-lg-12 d-flex justify-content-end">
          <div class="col-lg-12 p-0 text-start">
                <a
                  class="p-0 back-button"
                  style="cursor: pointer"
                  :title="$t('key_button_back')"
                  @click="$router.go(-1)"
                >
                  <i class="fa fa-arrow-circle-left" style="font-size: 35px;"></i>
                </a>
          </div>
          <!-- div class="my-auto ms-auto">
            <button type="button" class="mt-2 mb-0 btn bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 " @click="save()">
              Guardar
            </button>     
          </div-->  
        </div>
      </div>
      <div class="mt-4 row" >
        <div class="col-lg-5">
          <div class="row h-100">
            <div class="col-lg-12">
              <FileVisualizer v-if="manifestId != null" :manifest-id='manifestId' />
            </div>
          </div>
        </div>
        <div class="col-lg-7 mt-lg-0">
          <div class="row h-100">
            <div class="col-lg-12">
              <form ref='editManifestForm' class="needs-validation h-100" novalidate>
                <ManifestInfo @save='save' />
              </form>
              <!-- div class="card cardimage h-100">
                <div class="card-body h-100">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <label>N. Manifiesto <span style="color:red">*</span> </label>
                      <input v-model="manifest.number" class="form-control" type="text" maxLength="50" required/>
                    </div>
                    <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                      <label>Transporte <span style="color:red">*</span> </label>
                      <input v-model="manifest.couries" class="form-control" required />
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                      <label>Operario</label>
                      <input v-model="manifest.operator" class="form-control" type="text" maxLength="50" />
                    </div>
                    <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                      <label>Fecha</label>
                      <input v-model="manifest.date" class="form-control" type="date"/>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-sm-12">
                      <label>Estado <span style="color:red">*</span> </label> 
                      <hk-select v-model="manifest.status" :options="statusOptions" required> </hk-select>                     
                    </div>
                  </div>
                </div>
              </div-->
            </div>
          </div>
        </div>
      </div>
    <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
  </div>
</template>

<script>
// import HkSelect from "@/hotaka/components/HkSelect.vue";
import { FileVisualizer } from "@/hotaka/components";
import SoftSnackbar from "@/components/SoftSnackbar.vue";
import ManifestInfo from "../components/ManifestInfo.vue";
export default {
  name: "EditManifest",
  components: {
    // HkSelect,
    SoftSnackbar,
    FileVisualizer,
    ManifestInfo
  },
  data() {
    return {
      manifest: {
        number: '',
        date: '',
        operator: null,
        status: 'PENDIENTE',
        couries: null, 
      },
      configDate: {
        allowInput: true,
      },
      statusOptions:[
        {
          value: 'PENDIENTE',
          label: this.$t('key_pod_status_pending'),
        },
        {
          value: 'ENTREGADO',
          label: this.$t('key_pod_status_delivered'),
        }
      ],
      choicesComposition: null,
      manifestId: null,
      notificationInfo:{
        title: '',
        message: '',
        status: 'danger'
      },
      showNotification: false,
    }
  },
  computed: {
    manifestData() {
      return this.$store.state.manifiest.manifest.data;
    },
    editStatus(){
      return this.$store.state.manifiest.updateManifest.status
    },
  },
  watch:{
    manifestData(val) {
      if(val){
        let manifestEntity = { ...this.$store.state.manifiest.manifest.data }

        this.manifest = {
          ...manifestEntity,
          date: manifestEntity.date ? this.$dateUtils.toFormat(manifestEntity.date, 'yyyy-MM-DD') : null,
        }
      }
    },
    editStatus(newValue) {
      if (newValue['updated']) {
        this.loadStatusNotification(newValue)
      } else  {
        const { error: { error } } = newValue
        let message = this.$t('key_error_on_saving')
        if (error) {
          message = error
        }
        this.notificationInfo = {
          title: 'Ups! Lo Sentimos',
          message: message,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
    },
  },
  mounted() {
    this.manifestId = this.$route.params.id;
    if(this.manifestId){
      this.$store.commit("manifiest/getManifest",this.$route.params.id);
    }
  },
  methods: {
    save(manifest){
      let form = this.$refs.editManifestForm;
      if (form.checkValidity()) {
        this.$store.commit("manifiest/updateManifest", manifest);
      }
      form.classList.add('was-validated')
    },
    closeNotificationAndRedirect(){
      const self= this;
      setTimeout(function () {
          self.$router.push({
            name: "Manifiestos"
          });
      }, 1050);
    },
    closeNotification(){
      const self= this;
      setTimeout(function () {
          self.showNotification = false
      },2000);
    },
    loadStatusNotification(value){
        if (value.status == 'KO') {
          this.notificationInfo = {
            title: 'Ups! Lo Sentimos',
            message: value.data.error,
            status: 'error'
          }
          this.showNotification = true;
          this.closeNotification();
        } else {
          this.notificationInfo = {
            title: this.$t('key_pod_successfully_saved'),
            message: this.$t('key_pod_successfully_saved_message'),
            status: 'success'
          }
          this.showNotification = true;
          this.closeNotificationAndRedirect();
        }
    },
  },
};
</script>

<style lang="scss" scoped>

.noimageColorEdit{ 
  opacity: 0.1 !important;  
}


.picture-cursor {
  cursor: url('../../../assets/img/zoom-in.svg'), auto;
}

.cardimage {
  position: inherit !important;
}

.form-control:disabled{
  background-color: white;
  border: 1px solid transparent;
}
.noimageColor{ 
  opacity: 0.1 !important;
}

.back-button {
  color: #4A7062
}

.manifest-image {
  object-fit: contain;
  transition: transform .2s;
  border-radius: 10px;
  transition: all 0.2s ease-in-out;
  border-radius: 6px;
}
</style>

 